import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { AvatarSize } from "marketplace/_views/avatars/avatar-size";
import { useGetIndividualAvatarQuery } from "marketplace/individuals/_api/individual-api";
import { getIndividualAvatar } from "marketplace/individuals/_stores/individuals-redux-slice";
import Individual from "marketplace/individuals/individual";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type IndividualAvatarProps = {
  className?: string;
  individual?: Individual;
  disabled?: boolean;
  size?: AvatarSize;
};

export default function IndividualAvatar(props: Readonly<IndividualAvatarProps>) {
  const { className, individual, disabled } = props;
  const size = props.size ?? "small";

  const base64AvatarData = useSelector(getIndividualAvatar((individual?.profile.avatarId && individual.id) ?? null, size));
  const { isLoading: isLoadingAvatar } = useGetIndividualAvatarQuery(
    { individualId: individual?.id?.value ?? "", size },
    { skip: !individual?.profile.avatarId || !!base64AvatarData || !individual?.id },
  );

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar 
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData 
            && isLoadingAvatar
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
